import React from 'react';
import { AdPreview } from './AdPreview';
import { VERSIONS } from './data';
import { Version } from './types';
interface AdPanelProps {
  version: Version;
  scanning: boolean;
  comparing: boolean;
  compareVersionId: string;
  onCompareVersionChange: (id: string) => void;
  activeVersionId: string;
  isSubmitter: boolean;
  onUpload: () => void;
}
export function AdPanel({
  version,
  scanning,
  comparing,
  compareVersionId,
  onCompareVersionChange,
  activeVersionId,
  isSubmitter,
  onUpload
}: AdPanelProps) {
  const hasBlockers = version.blockers.length > 0;
  return <>
      {/* Compare Panel */}
      {comparing && <div style={{
      background: '#F4F1EC',
      borderRight: '1px solid #E6E4DF',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-19">
          <div style={{
        padding: '8px 12px',
        borderBottom: '1px solid #E6E4DF',
        background: 'rgba(255,255,255,0.5)'
      }} data-id="element-20">
            <select value={compareVersionId} onChange={e => onCompareVersionChange(e.target.value)} style={{
          fontSize: 12,
          fontWeight: 700,
          border: '1px solid #E6E4DF',
          borderRadius: 5,
          padding: '4px 8px',
          fontFamily: 'inherit',
          background: 'white'
        }} data-id="element-21">
              {VERSIONS.filter(x => x.id !== activeVersionId).map(x => <option key={x.id} value={x.id} data-id="element-22">
                  {x.label}
                </option>)}
            </select>
          </div>
          <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20
      }} data-id="element-23">
            <div style={{
          maxWidth: 320,
          width: '100%',
          opacity: 0.7
        }} data-id="element-24">
              <AdPreview ad={VERSIONS.find(x => x.id === compareVersionId)!.ad} compact data-id="element-25" />
            </div>
          </div>
        </div>}

      {/* Main Ad Panel */}
      <div style={{
      background: '#EEEAE4',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-26">
        <div style={{
        padding: '7px 12px',
        borderBottom: '1px solid #E6E4DF',
        background: 'rgba(255,255,255,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }} data-id="element-27">
          <span style={{
          fontSize: 12,
          fontWeight: 700
        }} data-id="element-28">
            {version.label}{' '}
            <span style={{
            fontWeight: 400,
            color: '#8896A6'
          }} data-id="element-29">
              {version.time}
            </span>
          </span>
          {hasBlockers ? <span style={{
          fontSize: 11,
          fontWeight: 800,
          color: '#B44D4D'
        }} data-id="element-30">
              {version.blockers.length} blocker
              {version.blockers.length > 1 ? 's' : ''}
            </span> : <span style={{
          fontSize: 11,
          fontWeight: 800,
          color: '#16785E'
        }} data-id="element-31">
              ✓ Clear
            </span>}
        </div>

        <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
        overflowY: 'auto'
      }} data-id="element-32">
          {scanning ? <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 12
        }} data-id="element-33">
              <div style={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            border: '3px solid #E6E4DF',
            borderTopColor: '#2D7A6E',
            animation: 'spin 0.8s linear infinite'
          }} data-id="element-34" />
              <div style={{
            fontSize: 13,
            fontWeight: 700
          }} data-id="element-35">
                Scanning…
              </div>
            </div> : <div style={{
          maxWidth: comparing ? 320 : 400,
          width: '100%'
        }} data-id="element-36">
              <AdPreview ad={version.ad} compact={comparing} blockers={version.blockers} suggestions={version.suggestions} data-id="element-37" />
            </div>}
        </div>

        {isSubmitter && <div style={{
        padding: '8px 12px',
        borderTop: '1px solid #E6E4DF',
        background: 'rgba(255,255,255,0.5)'
      }} data-id="element-38">
            <button onClick={onUpload} style={{
          width: '100%',
          padding: 8,
          borderRadius: 6,
          border: '1.5px dashed #B8AFA6',
          background: 'white',
          color: '#5A6B7C',
          fontWeight: 600,
          fontSize: 11.5,
          cursor: 'pointer',
          fontFamily: 'inherit'
        }} data-id="element-39">
              ↑ Upload New Version
            </button>
          </div>}
      </div>
    </>;
}